import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const scoutingPlayersSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.SCOUTING_TOURNAMENT}`,
        popover: {
            title: "Tournament Selector",
            description:
                "Choose which tournament's data you want to scout. All player stats in the table will update to reflect the selected tournament.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_NAV}`,
        popover: {
            title: "Scouting Sections",
            description:
                "Switch between <b>Players Rating Scouting</b> for skaters and <b>Goalkeepers Rating Scouting</b> for goaltenders. Each section has its own set of stat categories.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_SEARCH}`,
        popover: {
            title: "Search by Name",
            description: "Quickly find a specific player by typing their name. The table filters in real time.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_POSITION_FILTER}`,
        popover: {
            title: "Position Filter",
            description:
                "Filter the table to show only players of selected positions (C, LW, RW, LD, RD). Select multiple positions to compare across roles. You can also <b>click a role value directly in the table</b> to instantly set this filter.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_TEAM_FILTER}`,
        popover: {
            title: "Team Filter",
            description:
                "Filter by one or more teams using this dropdown. You can also <b>click a team name directly in the table</b> to add it to the filter.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_STAT_CATEGORY}`,
        popover: {
            title: "Stat Category",
            description:
                "Switch between different stat groupings — Overview, Skating, Puck Control, Actions, Passing, and Advanced — to change which columns are displayed in the table.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SCOUTING_PLAYERS_TABLE}`,
        popover: {
            title: "Player Table",
            description:
                "Every row is a player. Click any row to open their full profile with detailed stats, heatmaps, and KPI history.",
        },
    },
];
